export default "__VITE_ASSET__CPp1XN_X__"